import { customImageLoader } from "@yardzen/next-client-util";
import { cn } from "../lib/utils";
import { ContentfulText } from "./contentful-text";
import { Icon, isIconName } from "./icon";
import { P } from "./p";
import { Asset, AssetLink, ChainModifiers } from "contentful";
import Image from "next/image";

export function ListItem({
  iconName,
  heading,
  subheading,
  className,
  headingClassName,
  subHeadingClassName,
  iconWrapperClassName,
  iconClassName,
  iconSize,
  description,
  logoGrid,
}: {
  iconName?: string;
  heading?: string;
  subheading?: string;
  className?: string;
  headingClassName?: string;
  subHeadingClassName?: string;
  iconWrapperClassName?: string;
  iconClassName?: string;
  iconSize?: "sm" | "md" | "lg";
  description?: string | null;
  logoGrid?: (Asset<ChainModifiers, string> | AssetLink | undefined)[];
}) {
  return (
    <div
      className={cn(
        className
          ? className
          : "bg-brand-beige-lighter mb-2 flex flex-row items-center gap-2 rounded-md p-4 ",
      )}
    >
      {iconName && isIconName(iconName) && (
        <div
          className={cn(
            "flex h-fit w-fit shrink-0 items-center rounded-full bg-white p-1.5",
            iconWrapperClassName,
          )}
        >
          <Icon
            name={iconName}
            className={cn(
              "text-brand-primary-regular h-[19px] w-[19px]",
              iconClassName,
            )}
            size={iconSize}
          />
        </div>
      )}
      {description ? (
        <div className="flex flex-col text-left">
          <ContentfulText
            content={description}
            className="font-body text-left font-normal"
            pClassName="mb-0 font-body text-left text-[15px] font-normal [&:has(+ul)]:font-semibold"
            ulClassName="mt-2 space-y-1.5 text-[13px] leading-snug"
            listMarker="check"
          ></ContentfulText>
          {logoGrid && logoGrid.length > 0 && (
            <div className="mt-1.5 flex flex-wrap items-center gap-2.5">
              {logoGrid.map((asset) => {
                if (!asset) return null;
                const assetData = "fields" in asset ? asset : null;
                if (!assetData?.fields?.file?.url) return null;

                const imageUrl = String(assetData.fields.file.url);
                const imageAlt = String(
                  assetData.fields.title ||
                    assetData.fields.file.fileName ||
                    "Logo",
                );

                return (
                  <div
                    key={assetData.sys.id}
                    className="flex h-[16px] items-center"
                  >
                    <Image
                      src={imageUrl}
                      alt={imageAlt}
                      className="h-full w-auto max-w-[80px] object-contain"
                      height={16}
                      width={120}
                      loading="lazy"
                      loader={customImageLoader}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-col text-left">
          {heading && (
            <P
              className={cn(
                headingClassName
                  ? headingClassName
                  : "text-brand-secondary-dark text-xs leading-none md:text-base",
              )}
              noSpacing
            >
              {heading}
            </P>
          )}

          {subheading && (
            <P
              className={cn(
                subHeadingClassName
                  ? subHeadingClassName
                  : "text-brand-secondary-dark mt-1 text-xs leading-none",
              )}
              noSpacing
            >
              {subheading}
            </P>
          )}
        </div>
      )}
    </div>
  );
}
